//REDUCER

import {  RECIEVE_LOGOUT, RECIEVE_LOGIN, RECIEVE_USER_METADATA, SET_SPOTTER_STATE, SET_SPOTTER_COUNTY,} from '../actions'

import { createAction, createReducer } from '@reduxjs/toolkit'


const initialUserMetataState = {
	logged_in : false,
	userName: "",
	firstName: "",
	lastName: "",
	email: "",
	uid: null,
	isSpotter: false,
	spotter_state: null,
	spotter_county: null
};


const userMetadata = createReducer(initialUserMetataState, (builder) => {
    builder
	.addCase(createAction(RECIEVE_LOGIN), (state, action) => {
        
		if(action.json.error === "none")
		{
			state.logged_in = true;
					
		}else
		{
			state.logged_in  = false;
		}
	})
	.addCase(createAction(RECIEVE_LOGOUT), (state, action) => {
		state.logged_in  = false;
	})
	.addCase(createAction(RECIEVE_USER_METADATA), (state, action) => {

		state.logged_in = action.userMetadata.logged_in;
		state.userName = action.userMetadata.userName;
		state.firstName = action.userMetadata.firstName;
		state.lastName = action.userMetadata.lastName;
		state.email = action.userMetadata.email;
		state.uid = action.userMetadata.uid;
		state.isSpotter = action.userMetadata.isSpotter;
		state.spotter_state = action.userMetadata.spotter_state;
		state.spotter_county = action.userMetadata.spotter_county;
	
	})
	.addCase(createAction(SET_SPOTTER_STATE), (state, action) => {
		state.spotter_state = action.state;
	
	})
	.addCase(createAction(SET_SPOTTER_COUNTY), (state, action) => {
		state.spotter_county = action.county;

	})

  })


export default userMetadata
